import { useCallback, useEffect, useState } from "react";

import { LogOutIcon } from "lucide-react";

import { LogoutButton } from "@/features/LogoutButton";

import { Modal } from "@/shared/ui/Modal";

export const LogoutModal = () => {
  const [open, setOpen] = useState(false);

  const openModal = useCallback(() => setOpen(true), [setOpen]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key === "b") {
        event.preventDefault();
        openModal();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [openModal]);

  return (
    <Modal open={open} onOpenChange={setOpen}>
      <Modal.Trigger
        variant="ghost"
        className="flex items-center gap-2 px-0 text-textColor"
      >
        <LogOutIcon className="text-textColor" size={20} />
        Выход
      </Modal.Trigger>
      <Modal.Content>
        <Modal.Title>Подтверждение выхода</Modal.Title>
        <p className="text-textColor">
          Вы действительно хотите выйти из аккаунта?
        </p>
        <div className="flex flex-col items-center gap-2">
          <LogoutButton />

          <Modal.Close />
        </div>
      </Modal.Content>
    </Modal>
  );
};
